import * as React from "react";

function SvgUpload(props) {
  return <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M19.24 4.416c.256-.256.608-.416.992-.416s.768.128 1.024.416l10.368 10.368-2.016 2.016-7.936-7.968v21.056h-2.848V8.832L10.888 16.8l-2.016-2.016L19.24 4.416zM32.648 32.32v-4.352h2.784v4.352a3.68 3.68 0 01-3.68 3.68H8.68A3.68 3.68 0 015 32.32v-4.352h2.848v4.352c0 .48.384.864.864.864h23.072a.86.86 0 00.864-.864z" fill="#fff" /></svg>;
}

export default SvgUpload;